export default __webpack_public_path__ + "static/media/4_3.3c97dbf4.jpg";